import { ReactNode } from 'react';
import styled from 'styled-components';
import { Card, Container, Stack } from '@optimus-web/core';

/*
 * this heights are needed to match cards between siblings, for example in a Grid.
 * And also to distribute the title and chart in Card.
 */

const CardStyled = styled(Card)`
    height: 100%;
`;
const StackStyled = styled(Stack)`
    height: 100%;
`;

export const CardContainer = ({ children, ...other }: { children: ReactNode }) => (
    <Container maxWidth="100%" height="100%" {...other}>
        <CardStyled padding="200">
            <StackStyled vertical spacing="150" distribution="space-between">
                {children}
            </StackStyled>
        </CardStyled>
    </Container>
);
